export const LABEL_DE = 'De';
export const LABEL_ATE = 'Até';
export const LABEL_TAXA_JUROS = 'Taxa de Juros';
export const LABEL_REPASSE = 'Repasse';
export const LABEL_DIAS = '(dias)';
export const LABEL_PORCENTAGEM = '(%)';
export const TOOLTIP_TRASH = 'Excluir Faixas de Juros';
